import React, { useState, useRef } from "react";
import { GC_USER_ID, GC_AUTH_TOKEN } from "./constants";
import CreateUserMutation from "./mutations/CreateUserMutation";
import { useNavigate, Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import EmailValidator from "email-validator";
import "./SignupForm.css";
import { ToastContainer, toast } from "react-toastify";
import { useThemeUpdate } from "./contexts/ThemeContext";
import {
	CURRENCY_CODES,
	SUPPORTED_CURRENCIES,
	CURRENCY_RATES,
	getUnitPrice
} from "./data/currency_codes";
import Select from "react-select";

const {
	REACT_APP_PRICE_YEARLY_DOLLARS,
	REACT_APP_PRICE_MONTHLY_DOLLARS,
    REACT_APP_SITE_KEY
} = process.env;

function SignupForm(props) {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [timeZone, setTimeZone] = useState(
		Intl.DateTimeFormat().resolvedOptions().timeZone
	);
	const [currency, setCurrency] = useState("");
	const [message, setMessage] = useState("");
	const toggleTheme = useThemeUpdate();

	const navigate = useNavigate();
	const reRef = useRef();

	const SITEKEY = REACT_APP_SITE_KEY;

	const isValidEmail = EmailValidator.validate(email) ? true : false;
	const messageSuccess = () => toast("Signed up successfully!");

	const _saveUserData = (id, token) => {
		localStorage.setItem(GC_USER_ID, id);
		localStorage.setItem(GC_AUTH_TOKEN, token);
	};

	const [signupError, setSignupError] = useState("");

	const customStyles = {
		placeholder: (provided, state) => ({
			...provided,
			fontSize: 14
		}),
		option: (provided, state) => ({
			...provided,
			fontSize: 14
		}),

		singleValue: (provided, state) => ({
			...provided,
			fontSize: 14
		}),

		group: (provided, state) => ({
			...provided,
			fontSize: 14,
			border: 1,
			backgroundColor: "green"
		})
	};

	function onCountrySelectChange(country) {
		const selected_currency = country["value"]["currencyCode"];
		// setCurrency(selected_currency);
		// console.log(selected_currency);
		if (SUPPORTED_CURRENCIES.includes(selected_currency)) {
			setCurrency(selected_currency);
			// console.log(
			// 	Math.round(
			// 		getUnitPrice(selected_currency) *
			// 			REACT_APP_PRICE_MONTHLY_DOLLARS
			// 	)
			// );
		} else {
			setCurrency("usd");
			// console.log(
			// 	Math.round(
			// 		getUnitPrice("usd") * REACT_APP_PRICE_MONTHLY_DOLLARS
			// 	)
			// );
		}
	}

	async function onSubmit(event) {
		event.preventDefault();
		if (!isValidEmail) {
			setSignupError("Enter a valid email!");
		}

		const recaptchaToken = await reRef.current.executeAsync();
		console.log(recaptchaToken);
		reRef.current.reset();
		let formData = {
			email: email,
			password: password,
			time_zone: timeZone
		};

		if (password === "") {
			setSignupError("Password cannot be blank!");
		}

		if (currency == "") {
			setSignupError("Select a country!");
		}

		if (isValidEmail && password != "" && currency != "") {
			CreateUserMutation(
				email,
				password,
				recaptchaToken,
				currency,
				(id, token) => {
					if (
						id != null &&
						token != null &&
						email != "" &&
						password != ""
					) {
						_saveUserData(id, token);
						messageSuccess();
						navigate("/home");
					} else {
						setSignupError("Account already exists!");
					}
				}
			);
		}

		toggleTheme("light");
	}

	return (
		<div className="signupform-main-container">
			<ToastContainer
				position="bottom-right"
				autoClose={5000}
				hideProgressBar
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<div className="signupform-wrapper">
				<div className="signupform-container">
					<label className="signup-title">Create an Account</label>
					<form onSubmit={onSubmit} className="signup-form">
						<input
							placeholder="Email"
							className="standard-textfield"
							name="email"
							type="text"
							value={email}
							onChange={e => {
								setEmail(e.target.value);
								setSignupError("");
							}}
						/>
						<input
							placeholder="Password"
							className="standard-textfield"
							name="password"
							type="password"
							value={password}
							onChange={e => setPassword(e.target.value)}
						/>
						{signupError.length != 0 ? (
							<div className={`message-container`}>
								<p>{signupError}</p>
							</div>
						) : null}
						<Select
							styles={customStyles}
							placeholder="Country"
							options={CURRENCY_CODES}
							onChange={onCountrySelectChange}
							isMulti={false}
						/>

						<div className={`clause-container`}>
							<p className={`clause`}>
								By clicking Create an Account, you agree to the
								Terms and Privacy Policy.
							</p>
						</div>
						<input
							type="submit"
							className="standard-action-button"
							value="Create Account"
						/>

						{/*
						<label>
							Already a member? &nbsp;
							<Link className="login-link" to="/login">
								Login
							</Link>
						</label>
			
			*/}
					</form>
				</div>
				{/*
			
				<div className={`clause-container`}>
					<p className={`clause`}>
						By clicking Create Account, you agree to the Feedgram
						Terms and Privacy Policy.
					</p>
				</div>
			*/}
			</div>
			<div className="recaptcha-container">
				<ReCAPTCHA sitekey={SITEKEY} size="invisible" ref={reRef} />
			</div>
		</div>
	);
}

export default SignupForm;
